import { Controller } from "@hotwired/stimulus"

// Dropped pictures' painted pictures (dashboard/dropped_pictures): the ticked
// ones counted for the buttons over the list, which say what they'll do
// ("Add 3 to 2 figures", "Remove 3"), and a line naming each figure the
// pictures go on; and Tick all. The tick boxes belong to the #dp_bulk form;
// pictures added or removed leave the page, so the count is taken afresh each time.
export default class extends Controller {
  static targets = ["button", "add", "remove", "note", "all", "list"]

  // Watching only the list (not the note this rewrites, which would set it off again).
  connect() {
    this.observer = new MutationObserver(() => this.count())
    if (this.hasListTarget) this.observer.observe(this.listTarget, { childList: true, subtree: true })
    this.count()
  }

  disconnect() { this.observer.disconnect() }

  boxes() { return [...document.querySelectorAll("input[form='dp_bulk'][name='ids[]']:not(:disabled)")] }

  all(event) {
    this.boxes().forEach((box) => { box.checked = event.target.checked })
    this.count()
  }

  count() {
    const boxes = this.boxes()
    const ticked = boxes.filter((box) => box.checked)
    // Each figure with how many pictures Add puts on it (a found photo in two parts adds two).
    const figures = new Map()
    ticked.forEach((box) => figures.set(box.dataset.figure, (figures.get(box.dataset.figure) || 0) + Number(box.dataset.pictures || 1)))
    const pictures = [...figures.values()].reduce((a, b) => a + b, 0)
    this.buttonTargets.forEach((button) => { button.disabled = ticked.length === 0 })
    const add = ticked.length ? `Add ${pictures}${figures.size > 1 ? ` to ${figures.size} figures` : ""}` : "Add ticked"
    const remove = ticked.length ? `Remove ${ticked.length}` : "Remove ticked"
    if (this.hasAddTarget && this.addTarget.textContent !== add) this.addTarget.textContent = add
    if (this.hasRemoveTarget && this.removeTarget.textContent !== remove) this.removeTarget.textContent = remove
    const named = [...figures].map(([name, n]) => (figures.size > 1 ? `${name} (${n})` : name)).join(", ")
    const note = ticked.length
      ? `Add puts ${pictures === 1 ? "1 picture" : `${pictures} pictures`} on ${figures.size > 1 ? `${figures.size} figures: ${named}` : named}`
      : "Tick pictures to add or remove together."
    if (this.hasNoteTarget && this.noteTarget.textContent !== note) this.noteTarget.textContent = note
    if (this.hasAllTarget) this.allTarget.checked = boxes.length > 0 && ticked.length === boxes.length
  }
}
